import React, { FC } from "react";

import { Avatar, Box, Typography } from "@mui/material";
import { theme } from "@ovou-inc/ovou-ui";
import { IContactUser } from "../types/Contact";
import { generateMediaPath } from "utils";

interface ITableContactUserColumnProps {
  contactUser: IContactUser;
  onOpenUserDrawer: (contactId: string, handle: string) => void;
}

export const TableContactUserColumn: FC<ITableContactUserColumnProps> =
  React.memo(({ contactUser, onOpenUserDrawer }) => {
    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
      event.stopPropagation();
      onOpenUserDrawer(contactUser.id.toString(), contactUser.handle);
    };

    return (
      <Box
        display="flex"
        alignItems="center"
        gap={1}
        onClick={event => handleClick(event)}
      >
        <Avatar
          sx={{ width: 46, height: 64, borderRadius: "10px" }}
          variant="square"
          src={
            contactUser.photo_url
              ? generateMediaPath(contactUser.photo_url)
              : ""
          }
        />
        <Box>
          <Typography
            fontWeight="bold"
            fontSize="0.875rem"
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            color={theme.palette.brand.primary.black}
          >
            {contactUser.name}
          </Typography>
          <Typography
            fontWeight="semibold"
            style={{ whiteSpace: "normal", wordBreak: "break-all" }}
            fontSize="0.875rem"
            color={theme.palette.brand.primary.black}
          >
            {contactUser.email}
          </Typography>
        </Box>
      </Box>
    );
  });
